import { ISkeletonData, ITrackEntry, Spine } from "pixi-spine";
import { Assets, Container } from "pixi.js";
import { PlayWindow } from "../api";
import { Rect, Safe, Size } from "../MyHelpers";
import { AtlasResource } from "../ResourceManager/AtlasResource";
import { JSONResource } from "../ResourceManager/JSONResource";
import { Resourceful } from "../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager } from "../ResourceManager/ResourceManager";
import { Settings } from "../Settings";
import { IAnticipation } from "./AnticipationFactory/AnticipationFactory";
import { AnticipationDefault } from "./AnticipationFactory/AnticipationDefault";

export interface AnticipacionItem {
    isHiden: boolean,
    spine: Spine
}

export class AnticipacionPIXIAPP extends AnticipationDefault implements Resourceful{
    protected constainerAnticipation : Container = null;
    //protected windowRectangle: PixelRect = null;
    public constructor( playWindow : PlayWindow , symbolSize : Size , gameName : string ){
        super(playWindow, symbolSize, gameName);

        //this.windowRectangle = windowRectangle;
    }

    public override async PrepareResources( resourceManager: IWriteOnlyResourceManager) {
        resourceManager.AddGlobal(new JSONResource(`${Settings.ResourcesFolder}multigame/slot/${this.gameName}/resources/SpineResources/Anticipation/Anticipation.json`,ResourceIdentifier.Global.ScopedResourceName(`${this.gameName}-AnticipationAnimationSpine-JSON`), true));
        resourceManager.AddGlobal(new AtlasResource(`${Settings.ResourcesFolder}multigame/slot/${this.gameName}/resources/SpineResources/Anticipation/Anticipation.atlas`, ResourceIdentifier.Global.ScopedResourceName(`${this.gameName}-AnticipationAnimationSpine-ATLAS`), true));    
    }

    protected skeleton : ISkeletonData = null;
    public override async ResourcesLoaded( resourceManager: IReadOnlyResourceManager) {
        let json = resourceManager.Get<JSONResource>(ResourceIdentifier.Global.ScopedResourceName(`${this.gameName}-AnticipationAnimationSpine-JSON`));
		let assetJson = await Assets.load(json.path);
        this.skeleton = assetJson.spineData;
    }

    protected spineAnimationReelArray : AnticipacionItem [] = []
    public override Create(reelPositon: Rect[] , windowRectangle: Rect ) {
        this.constainerAnticipation = new Container();
        //this.constainerAnticipation.y = Settings.ScreenHeight * (Settings.Screens - 1);
        this.constainerAnticipation.name = "AnticipationContainer";
        
        for (let reel = 0; reel < this.playWindow.Width; reel++) {
            //Create Spine Animation 
            let spine: Spine = new Spine(this.skeleton);
            spine?.state?.addListener({
                complete: (entry: ITrackEntry) => {
                    if (entry.animation.name == "fadeout") spine.state.clearTracks()
                }
            });
            spine.visible = false;
            let boneSize = spine.spineData.findBone("Size");
            //console.log(`Anticipation - Spine Width : ${spine.width} Height : ${spine.height}`);
            //console.log(`Anticipation - Spine bone Width : ${boneSize.x} Height : ${boneSize.y}`);
            //console.log(`Anticipation -Reel  Width : ${reelPositon[reel].width} Height : ${reelPositon[reel].height}`);
            //console.log(`Anticipation -ReelDiference  Width : ${reelPositon[reel].width - boneSize.x} Height : ${reelPositon[reel].height - (boneSize.y * -1)}`);            
            spine.x = reelPositon[reel].x + windowRectangle.x;
            spine.y = reelPositon[reel].y + windowRectangle.y;
            let scaleWidth = reelPositon[reel].width / boneSize.x;
            let scaleHeight = reelPositon[reel].height / boneSize.y;
            //let scaleX = Math.abs(Math.min(scaleHeight, scaleHeight));
            let ScaleX= Math.abs(Math.min(scaleWidth, scaleWidth));
            let Scaley= Math.abs(Math.min(scaleHeight, scaleHeight));
            spine.width = spine.width * ScaleX;
            spine.height = spine.height * Scaley;
            this.constainerAnticipation.addChild(spine);
            
            spine.state.setAnimation(0, "fadeout", false);
            spine?.state.data.setMix("fadeout", "animation",0.5)
            spine?.state.data.setMix("animation", "fadeout",0.5)
            this.spineAnimationReelArray?.push({isHiden : true, spine : spine})                        
            //spine.state.setAnimation(1 , "fadeout" , false);   
           
        }
    }

    public override ShowReelAnimation(index: number) {

        //spine.visible = true;
        //this.spineAnimationReelArray?.[index].spine.state.setAnimation(0, "animation", true); 
        if (this.spineAnimationReelArray.length > 0 && this.spineAnimationReelArray?.[index].spine != null) {
            this.spineAnimationReelArray[index].spine.visible = true;
            this.spineAnimationReelArray?.[index]?.spine?.state?.setAnimation(0, "fadein", false);
            this.spineAnimationReelArray?.[index]?.spine?.state?.addAnimation(0, "animation", true, 0);
            this.spineAnimationReelArray[index].isHiden = false;
        }
        //spine = null;

    }

    public override HideReelAnimation(index: number) {        
        if (this.spineAnimationReelArray?.[index].isHiden == false) {
            this.spineAnimationReelArray?.[index]?.spine?.state?.setAnimation(1, "fadeout", false);
            this.spineAnimationReelArray[index].isHiden = true;
        }
    }

    public override GetView() : Container{
        return this.constainerAnticipation
    }

    public override Destroy(){
        this.spineAnimationReelArray?.forEach(ele=>{
            Safe(() =>{ele?.spine?.state?.clearTracks()});
            Safe(() =>{ele?.spine?.state?.clearListeners()});
            //ele.spine?.removeFromParent();
            Safe(() =>ele?.spine?.destroy());
        })
        this.constainerAnticipation.destroy({children : true});
        this.spineAnimationReelArray = [];                
    }
}